import { forwardRef } from 'react'

import { TextContainer } from 'components/container'
import { Section } from 'components/misc'
import { AnimatedFigcaption } from 'components/animated-figcaption'
import ReindeerSrc from './assets/reindeer.webp'
import { FigCaption, Figure, Img } from './styled'

export const Reindeer = forwardRef<HTMLDivElement, {}>((_, ref) => (
  <Section>
    <TextContainer>
      <Figure>
        <AnimatedFigcaption
          description="Олень – одно из важнейших животных для саха. От состояния животных и сегодня зависит практически весь жизненный цикл кочевников-оленеводов."
          FigCaptionComponent={FigCaption}
        />
        <Img src={ReindeerSrc} alt="" />
      </Figure>
    </TextContainer>
  </Section>
))
